<template lang="pug">
.CartState
  button.total(@click="openCart" :class="this.cartContent.filter(item => item.style === 'birra').length > 0 && 'yellow'")
    span {{ this.cartContent.filter(item => item.style === 'birra').length > 0 ? 'Beer!' : cartSize }}
    svg.cart-icon(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 59.293 42.052')
      path(d='M28.38 37.552a4.5 4.5 0 11-4.5-4.5 4.5 4.5 0 014.5 4.5')
      path(d='M50.38 37.552a4.5 4.5 0 11-4.5-4.5 4.5 4.5 0 014.5 4.5')
      path(d='M51.184 28.52H19.1L13.332 5.846H2.62A2.639 2.639 0 010 3.189 2.639 2.639 0 012.62.532h15.31l5.763 22.674h23.8l6.585-20.913a2.621 2.621 0 115.19.728z')
  .notifications
    transition-group(name="notif"): p.notif(v-for="(notif, i) in notifications" :key="i + 1 - 1") {{ notif }}
</template>

<script>
export default {
  name: 'CartState',
  data() {
    return {
      cartSize: 0,
      notifications: [],
      cartContent: []
    }
  },
  methods: {
    openCart() {
      this.$router.push('/')
      this.$store.commit('openCart', true)
    }
  },
  computed: {
    cart() {
      return this.$store.state.words.filter(
        word => word.inCart && word.style !== 'image'
      )
    }
  },
  watch: {
    cart(newCart, oldCart) {
      this.cartSize = newCart.length
      this.cartContent = newCart.filter(word => word.inCart)
      if (this.cartSize > 0) {
        this.notifications.push(
          `"${newCart[newCart.length - 1].text.replace(
            /[¿?,.!… ]/g,
            ''
          )}" successfully added to cart`
        )
      }
      setTimeout(() => {
        this.notifications.splice(0, 1)
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.CartState {
  @include grid(0, 8);
  position: fixed;
  text-align: right;
  padding-top: $margins-d;
  font-size: $fs-xs;
  z-index: 4;

  .total {
    position: absolute;
    right: 0;
    display: inline-flex;
    margin: 0;
    color: black;
    background: none;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    padding-left: 0.1rem;
    font-variant-numeric: tabular-nums;
    border: none;
    line-height: 2;
    cursor: pointer;
    outline: none;

    span {
      // opacity: .5;
      font-weight: bold;
      line-height: 0.5;
      font-size: 1.4rem;
    }

    &.yellow span {
      color: black;
      opacity: 1;
      animation: blink 1s infinite;

      @keyframes blink {
        from,
        9%,
        20%,
        29%,
        40%,
        49% {
          opacity: 0;
        }
        10%,
        19%,
        30%,
        39%,
        50%,
        to {
          opacity: 1;
        }
      }
    }

    .cart-icon {
      fill: black;
      margin-left: 0.6rem;
      margin-right: 0.3rem;
      vertical-align: -0.1rem;
      width: 1.5em;
      transform: scale(2);
      transform-origin: left;
    }
  }

  .notifications {
    pointer-events: none;
    @include grid(0, 8);
    left: 0 !important;
    top: 5rem;

    > span {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    .notif {
      display: inline-block;
      margin: 0.25rem 0;
      text-align: left;
      color: $c-white;
      background: mix($c-set-txt, $c-set-bg, 20);
      border-radius: 0.5rem;
      padding: 0.3rem 1rem;

      &-leave-active {
        transition: all 1s;
      }

      &-enter-active {
        transition: all 1s $ease-out;
      }

      &-leave-to {
        opacity: 0;
        transform: translateX(-3rem);
      }

      &-enter {
        opacity: 0;
        transform: translateX(100%);
      }
    }
  }
}
</style>
